<app-template-editor 
            [elementId]="tinyId" 
            [height]="500"
            (onEditorContentChange)="onTextChange($event)"
            [(value)]="content"></app-template-editor>
